(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["PRODUCT-PAIR-WITH"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pair-with-products')) {
    customElements.define(
      'pair-with-products',
      class PairWithProducts extends HTMLElement {
        connectedCallback() {
          if (this.dataset.matchSelectedColor !== 'true' || typeof subscribe !== 'function') return;

          const productInfo = document.querySelector(`product-info[data-product-id="${this.dataset.productId}"]`);
          this.productSectionId = productInfo?.dataset.section;
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, this.handleVariantChange.bind(this));
        }

        disconnectedCallback() {
          this.unsubscribe?.();
          this.abortController?.abort();
        }

        async handleVariantChange({ data: { sectionId, variant } }) {
          if (!variant?.id || sectionId !== this.productSectionId) return;

          this.abortController?.abort();
          this.abortController = new AbortController();

          const url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          url.searchParams.set('section_id', this.dataset.sectionId);

          try {
            const response = await fetch(url.toString(), { signal: this.abortController.signal });
            if (!response.ok) return;

            const html = new DOMParser().parseFromString(await response.text(), 'text/html');
            const replacement = html.querySelector('pair-with-products');
            if (replacement) this.replaceWith(replacement);
          } catch (error) {
            if (error.name !== 'AbortError') throw error;
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scarfhold-palette-directory-teaser"] && !Shopify.designMode) return;
  try {
    
  class ScarfholdPaletteDirectoryTeaser {
    constructor(section) {
      this.section = section;
      if (section.dataset.motionEnabled !== 'true' || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      section.classList.add('is-motion-ready');
      if (!('IntersectionObserver' in window)) { section.classList.add('is-in-view'); return; }
      this.observer = new IntersectionObserver(([entry]) => section.classList.toggle('is-in-view', entry.isIntersecting), { rootMargin: '100px 0px' });
      this.observer.observe(section);
    }
  }
  const initScarfholdPaletteDirectoryTeasers = (scope = document) => {
    scope.querySelectorAll('[data-scarfhold-palette-directory-teaser]:not([data-initialized])').forEach((section) => {
      section.dataset.initialized = 'true';
      new ScarfholdPaletteDirectoryTeaser(section);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initScarfholdPaletteDirectoryTeasers(), { once: true });
  else initScarfholdPaletteDirectoryTeasers();
  document.addEventListener('shopify:section:load', (event) => initScarfholdPaletteDirectoryTeasers(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scarfhold-pattern-directory-teaser"] && !Shopify.designMode) return;
  try {
    
  class ScarfholdPatternDirectoryTeaser {
    constructor(section) {
      this.section = section;
      this.observer = null;
      this.init();
    }

    init() {
      if (
        this.section.dataset.motionEnabled !== 'true' ||
        window.matchMedia('(prefers-reduced-motion: reduce)').matches
      ) {
        return;
      }

      this.section.classList.add('is-motion-ready');

      if (!('IntersectionObserver' in window)) {
        this.section.classList.add('is-in-view');
        return;
      }

      this.observer = new IntersectionObserver(
        ([entry]) => this.section.classList.toggle('is-in-view', entry.isIntersecting),
        { rootMargin: '100px 0px' }
      );
      this.observer.observe(this.section);
    }
  }

  const initScarfholdPatternDirectoryTeasers = (scope = document) => {
    scope.querySelectorAll('[data-scarfhold-pattern-directory-teaser]:not([data-initialized])').forEach((section) => {
      section.dataset.initialized = 'true';
      new ScarfholdPatternDirectoryTeaser(section);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initScarfholdPatternDirectoryTeasers(), { once: true });
  } else {
    initScarfholdPatternDirectoryTeasers();
  }

  document.addEventListener('shopify:section:load', (event) => initScarfholdPatternDirectoryTeasers(event.target));

  } catch(e) { console.error(e); }
})();
})();
